var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLens({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 9C1.75 4.99594 4.99594 1.75 9 1.75C13.0041 1.75 16.25 4.99594 16.25 9C16.25 13.0041 13.0041 16.25 9 16.25C4.99594 16.25 1.75 13.0041 1.75 9ZM9 0.25C4.16751 0.25 0.25 4.16751 0.25 9C0.25 13.8325 4.16751 17.75 9 17.75C11.1462 17.75 13.1119 16.9773 14.6342 15.6949L17.4696 18.5304C17.7625 18.8233 18.2374 18.8233 18.5303 18.5304C18.8232 18.2375 18.8232 17.7626 18.5303 17.4697L15.6948 14.6343C16.9773 13.112 17.75 11.1463 17.75 9C17.75 4.16751 13.8325 0.25 9 0.25Z",
    fill: "#03422F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLens);
export default __webpack_public_path__ + "static/media/lens.c4c69a004612cde8cfb5eba0ae960f95.svg";
export { ForwardRef as ReactComponent };